import React from 'react';

import { observer } from 'mobx-react';
import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './HeaderRow.module.scss';
import { scanIqPaymentHistoryStore } from '../../../../stores/scanIqPaymentHistoryStore';
import { GridTableRow } from '../../../../../shared/components/table-components';
import { SortButtons } from '../../../../../shared/components/buttons';

const HeaderRow = observer(() => {
  const { filterMethods } = scanIqPaymentHistoryStore;

  const { handleSort, getIsSortedBy } = filterMethods;

  return (
    <GridTableRow variant="unstyled" className={classes.headerRow}>
      <SortButtons
        fieldName="PAYMENT_DATE"
        onSort={handleSort}
        getIsActive={getIsSortedBy}
      >
        Payment Date
      </SortButtons>
      <div>Subscription</div>
      <div>Type</div>
      <TitleWithDescription
        title="Total Amount"
        description="sales tax incl"
        titleFont="body-14-bold"
      />
      <div>Subtotal</div>
      <div>Status</div>
      <div>Invoice</div>
    </GridTableRow>
  );
});

export { HeaderRow };
